export default __webpack_public_path__ + "static/media/porterbuddy_logo_logo-only-white.33efd961.svg";